import React, { useEffect, useState } from "react"
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
} from "antd"
import axios from "axios"
import {
  AXIOS_IP_WATER,
  convertMomentObjects,
  generateTempId,
} from "../filingManagement/fileUploadService"
import { UploadFormItem } from "./UploadFormItem"
import { DateTimeFormatSimpleOnly } from "../../models/datetime"
import { MultipleRecords } from "./MultipleRecords"
import moment from "moment"
import { getWaterTypeName } from "./drinkWater"

export const WateTyperInfoModal = (props: {
  visible: boolean
  token: string
  waterType: number
  id?: number
  onOk: (v: any) => void
  onCancel: () => void
}) => {

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [data, setData] = useState<any>()

  const [form] = Form.useForm()

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setData(null)
    } else {
      if (props.id) {
        axios({
          url: `${AXIOS_IP_WATER}/waterHealthArchive/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: {id: props.id},
        }).then((res) => {
          const m = res.data.data
          form.setFieldsValue({
            maintenanceContactName: m.maintenanceContactName,
            maintenancePhone: m.maintenancePhone,
            healthApprovalExpiryDate: m.healthApprovalExpiryDate ? moment(m.healthApprovalExpiryDate) : '',
            qualityTestDate: m.qualityTestDate ? moment(m.qualityTestDate) : '',
            qualityTestResult: m.qualityTestResult,
          })
          setData({
            ...m,
            cleanDateApprovalUrl: m.cleanDateApprovalUrl ? m.cleanDateApprovalUrl?.map((v: any) => {
              return {
                ...v,
                date: v.date ? moment(v.date) : null
              }
            }) : [],
            changeDateApprovalUrl: m.changeDateApprovalUrl?.length ? m.changeDateApprovalUrl?.map((v: any) => {
              return {
                ...v,
                date: v.date ? moment(v.date) : null
              }
            }) : [],
          })
        })
        // form.setFieldsValue(data)
      }
    }
  }, [props.visible, props.id])

  return (
    <>
      <Modal
        title={getWaterTypeName(props.waterType)}
        width={1000}
        confirmLoading={confirmLoading}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div style={{ height: 600, overflow: "auto" }}>
          <Form
            form={form}
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 17 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setConfirmLoading(true)
              const params = convertMomentObjects({
                category: props.waterType,
                ...vs,
                id: props.id
              })
              axios({
                url: `${AXIOS_IP_WATER}/waterHealthArchive/saveOrUpdate`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": props.token,
                },
                withCredentials: false,
                method: "POST",
                data: params,
              }).then((res) => {
                props.onOk({
                  id: res.data.data,
                  category: props.waterType,
                })
              }).finally(() => {
                setConfirmLoading(false)
              })
            }}
          >
            <Form.Item
              name="maintenanceContactName"
              label="维保单位联系人"
              rules={[{ required: true }]}
            >
              <Input allowClear style={{ width: "60%" }} />
            </Form.Item>
            <Form.Item
              name="maintenancePhone"
              label="维保联系电话"
              rules={[
                {
                  required: true,
                },
                {
                  pattern: new RegExp(
                    /^\d{3}-\d{8}|\d{4}-\d{7}|^(1[3,4,5,6,7,8,9][0-9]{9})$/
                  ),
                  message: '请输入正确的联系电话',
                },
              ]}
            >
              <Input allowClear style={{ width: "60%" }} />
            </Form.Item>
            {props.waterType == 1 ? (
              <>
                <UploadFormItem
                  name="healthApprovalUrl"
                  label="管道分质供水卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.healthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ healthApprovalUrl: v })
                  }
                />
                <Form.Item
                  name="healthApprovalExpiryDate"
                  label="卫生许可证有效期限"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <UploadFormItem
                  name="productHealthApprovalUrl"
                  label="涉水产品卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.productHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ productHealthApprovalUrl: v })
                  }
                />
                <MultipleRecords
                  label="滤芯等耗材更换时间及卫生许可批件"
                  name="changeDateApprovalUrl"
                  required={false}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.changeDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ changeDateApprovalUrl: v })
                  }}
                />
                <MultipleRecords
                  label="饮水设备清洗消毒时间及照片"
                  name="cleanDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择饮水设备清洗消毒时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.cleanDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ cleanDateApprovalUrl: v })
                  }}
                />
                <UploadFormItem
                  name="disinfectantHealthApprovalUrl"
                  label="饮水设备清洗消毒剂卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.disinfectantHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ disinfectantHealthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="disinfectantManufacturerHealthApprovalUrl"
                  label="饮水设备清洗消毒剂生产企业卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={
                    data?.disinfectantManufacturerHealthApprovalUrl || []
                  }
                  changeForm={(v) =>
                    form.setFieldsValue({
                      disinfectantManufacturerHealthApprovalUrl: v,
                    })
                  }
                />
                <UploadFormItem
                  name="qualitySelfTestUrl"
                  label="水质自检记录"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualitySelfTestUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualitySelfTestUrl: v })
                  }
                />
                <Form.Item
                  name="qualityTestDate"
                  label="第三方水质检测时间"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <Form.Item
                  name="qualityTestResult"
                  label="第三方水质检测结果"
                  rules={[{ required: true }]}
                >
                  <Input allowClear style={{ width: "60%" }} />
                </Form.Item>
                <UploadFormItem
                  name="qualityTestReportUrl"
                  label="第三方水质检测报告"
                  type={2}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualityTestReportUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualityTestReportUrl: v })
                  }
                />
                <UploadFormItem
                  name="nameplatePhotoUrl"
                  label="设备铭牌照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.nameplatePhotoUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ nameplatePhotoUrl: v })
                  }
                />
                <UploadFormItem
                  name="ledgerPhotoUrl"
                  label="管道分质供水卫生管理台账照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.ledgerPhotoUrl || []}
                  changeForm={(v) => form.setFieldsValue({ ledgerPhotoUrl: v })}
                />
              </>
            ) : props.waterType == 3 ? (
              <>
                <UploadFormItem
                  name="healthApprovalUrl"
                  label="饮水机卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.healthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ healthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="productionLicenseUrl"
                  label="桶装水企业生产许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.productionLicenseUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ productionLicenseUrl: v })
                  }
                />
                <MultipleRecords
                  label="桶装水饮水机清洗消毒时间及照片"
                  name="cleanDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择桶装水饮水机清洗消毒时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.cleanDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ cleanDateApprovalUrl: v })
                  }}
                />
                <UploadFormItem
                  name="disinfectantHealthApprovalUrl"
                  label="饮水机清洗消毒剂卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.disinfectantHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ disinfectantHealthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="disinfectantManufacturerHealthApprovalUrl"
                  label="饮水机清洗消毒剂生产企业卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={
                    data?.disinfectantManufacturerHealthApprovalUrl || []
                  }
                  changeForm={(v) =>
                    form.setFieldsValue({
                      disinfectantManufacturerHealthApprovalUrl: v,
                    })
                  }
                />
                <UploadFormItem
                  name="qualitySelfTestUrl"
                  label="水质自检记录"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualitySelfTestUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualitySelfTestUrl: v })
                  }
                />
                <Form.Item
                  name="qualityTestDate"
                  label="水质检测时间"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <Form.Item
                  name="qualityTestResult"
                  label="水质检测结果"
                  rules={[{ required: true }]}
                >
                  <Input allowClear style={{ width: "60%" }} />
                </Form.Item>
                <UploadFormItem
                  name="qualityTestReportUrl"
                  label="水质检测报告"
                  type={2}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualityTestReportUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualityTestReportUrl: v })
                  }
                />
                <UploadFormItem
                  name="nameplatePhotoUrl"
                  label="机器机身上的铭牌照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.nameplatePhotoUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ nameplatePhotoUrl: v })
                  }
                />
                <UploadFormItem
                  name="ledgerPhotoUrl"
                  label="桶装水饮水机台账照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.ledgerPhotoUrl || []}
                  changeForm={(v) => form.setFieldsValue({ ledgerPhotoUrl: v })}
                />
              </>
            ) : props.waterType === 2 ? (
              <>
                <UploadFormItem
                  name="healthApprovalUrl"
                  label="净水器卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.healthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ healthApprovalUrl: v })
                  }
                />
                <MultipleRecords
                  label="净水器滤芯更换时间及卫生许可批件"
                  name="changeDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择净水器滤芯更换时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.changeDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ changeDateApprovalUrl: v })
                  }}
                />
                <MultipleRecords
                  label="饮水设备清洗消毒时间及照片"
                  name="cleanDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择饮水设备清洗消毒时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.cleanDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ cleanDateApprovalUrl: v })
                  }}
                />
                <UploadFormItem
                  name="disinfectantHealthApprovalUrl"
                  label="饮水设备清洗消毒剂卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.disinfectantHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ disinfectantHealthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="disinfectantManufacturerHealthApprovalUrl"
                  label="饮水设备清洗消毒剂生产企业卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={
                    data?.disinfectantManufacturerHealthApprovalUrl || []
                  }
                  changeForm={(v) =>
                    form.setFieldsValue({
                      disinfectantManufacturerHealthApprovalUrl: v,
                    })
                  }
                />
                <UploadFormItem
                  name="qualitySelfTestUrl"
                  label="水质自检记录"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualitySelfTestUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualitySelfTestUrl: v })
                  }
                />
                <Form.Item
                  name="qualityTestDate"
                  label="水质检测时间"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <Form.Item
                  name="qualityTestResult"
                  label="水质检测结果"
                  rules={[{ required: true }]}
                >
                  <Input allowClear style={{ width: "60%" }} />
                </Form.Item>
                <UploadFormItem
                  name="qualityTestReportUrl"
                  label="水质检测报告"
                  type={2}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualityTestReportUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualityTestReportUrl: v })
                  }
                />
                <UploadFormItem
                  name="nameplatePhotoUrl"
                  label="机器机身上的铭牌照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.nameplatePhotoUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ nameplatePhotoUrl: v })
                  }
                />
                <UploadFormItem
                  name="ledgerPhotoUrl"
                  label="净水器卫生管理台账照片"
                  type={3}
                  token={props.token}
                  required={false}
                  defaultValue={data?.ledgerPhotoUrl || []}
                  changeForm={(v) => form.setFieldsValue({ ledgerPhotoUrl: v })}
                />
              </>
            ) : props. waterType === 4 ? (
              <>
                <UploadFormItem
                  name="boilingWaterEquipmentUrl"
                  label="开水炉/茶水桶照片"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.boilingWaterEquipmentUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ boilingWaterEquipmentUrl: v })
                  }
                />
                <UploadFormItem
                  name="boilingWaterEquipmentCertUrl"
                  label="开水炉/茶水桶合格证"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.boilingWaterEquipmentCertUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ boilingWaterEquipmentCertUrl: v })
                  }
                />
                <MultipleRecords
                  label="饮水设备清洗消毒时间及照片"
                  name="cleanDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择饮水设备清洗消毒时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.cleanDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ cleanDateApprovalUrl: v })
                  }}
                />
                <UploadFormItem
                  name="disinfectantHealthApprovalUrl"
                  label="饮水设备清洗消毒剂卫生许可批件"
                  type={3}
                  token={props.token}
                  required={false}
                  defaultValue={data?.disinfectantHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ disinfectantHealthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="disinfectantManufacturerHealthApprovalUrl"
                  label="饮水设备清洗消毒剂生产企业卫生许可证"
                  type={3}
                  token={props.token}
                  required={false}
                  defaultValue={
                    data?.disinfectantManufacturerHealthApprovalUrl || []
                  }
                  changeForm={(v) =>
                    form.setFieldsValue({
                      disinfectantManufacturerHealthApprovalUrl: v,
                    })
                  }
                />
                <UploadFormItem
                  name="qualitySelfTestUrl"
                  label="水质自检记录"
                  type={3}
                  token={props.token}
                  required={false}
                  defaultValue={data?.qualitySelfTestUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualitySelfTestUrl: v })
                  }
                />
                <Form.Item
                  name="qualityTestDate"
                  label="水质检测时间"
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <Form.Item
                  name="qualityTestResult"
                  label="水质检测结果"
                >
                  <Input allowClear style={{ width: "60%" }} />
                </Form.Item>
                <UploadFormItem
                  name="qualityTestReportUrl"
                  label="水质检测报告"
                  type={2}
                  token={props.token}
                  required={false}
                  defaultValue={data?.qualityTestReportUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualityTestReportUrl: v })
                  }
                />
                <UploadFormItem
                  name="ledgerPhotoUrl"
                  label="开水炉/茶水桶卫生管理台账照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.ledgerPhotoUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ ledgerPhotoUrl: v })
                  }
                />
              </>
            ) : props.waterType === 5 ? (
              <>
                <UploadFormItem
                  name="healthApprovalUrl"
                  label="自建供水设施卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.healthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ healthApprovalUrl: v })
                  }
                />
                <Form.Item
                  name="healthApprovalExpiryDate"
                  label="卫生许可证有效期限"
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <UploadFormItem
                  name="productHealthApprovalUrl"
                  label="涉水产品卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.productHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ productHealthApprovalUrl: v })
                  }
                />
                <MultipleRecords
                  label="滤芯等耗材更换时间及卫生许可批件"
                  name="changeDateApprovalUrl"
                  required={false}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.changeDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ changeDateApprovalUrl: v })
                  }}
                />
                <MultipleRecords
                  label="饮水设备清洗消毒时间及照片"
                  name="cleanDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择饮水设备清洗消毒时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.cleanDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ cleanDateApprovalUrl: v })
                  }}
                />
                <UploadFormItem
                  name="disinfectantHealthApprovalUrl"
                  label="饮水设备清洗消毒剂卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.disinfectantHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ disinfectantHealthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="disinfectantManufacturerHealthApprovalUrl"
                  label="饮水设备清洗消毒剂生产企业卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={
                    data?.disinfectantManufacturerHealthApprovalUrl || []
                  }
                  changeForm={(v) =>
                    form.setFieldsValue({
                      disinfectantManufacturerHealthApprovalUrl: v,
                    })
                  }
                />
                <UploadFormItem
                  name="qualitySelfTestUrl"
                  label="水质自检记录"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualitySelfTestUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualitySelfTestUrl: v })
                  }
                />
                <Form.Item
                  name="qualityTestDate"
                  label="水质检测时间"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <Form.Item
                  name="qualityTestResult"
                  label="水质检测结果"
                  rules={[{ required: true }]}
                >
                  <Input allowClear style={{ width: "60%" }} />
                </Form.Item>
                <UploadFormItem
                  name="qualityTestReportUrl"
                  label="水质检测报告"
                  type={2}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualityTestReportUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualityTestReportUrl: v })
                  }
                />
                <UploadFormItem
                  name="nameplatePhotoUrl"
                  label="设备铭牌照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.nameplatePhotoUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ nameplatePhotoUrl: v })
                  }
                />
                <UploadFormItem
                  name="ledgerPhotoUrl"
                  label="自建供水卫生管理台账照片"
                  type={3}
                  token={props.token}
                  required={false}
                  defaultValue={data?.ledgerPhotoUrl || []}
                  changeForm={(v) => form.setFieldsValue({ ledgerPhotoUrl: v })}
                />
              </>
            ) : props.waterType === 6 ? (
              <>
                <UploadFormItem
                  name="secondaryWaterSupplyEquipmentUrl"
                  label="二次供水设备照片"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.secondaryWaterSupplyEquipmentUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ secondaryWaterSupplyEquipmentUrl: v })
                  }
                />
                <UploadFormItem
                  name="productHealthApprovalUrl"
                  label="供水设施涉水产品卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  maxCount={3}
                  defaultValue={data?.productHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ productHealthApprovalUrl: v })
                  }
                />
                <MultipleRecords
                  label="涉水产品更换时间及卫生许可批件"
                  name="changeDateApprovalUrl"
                  required={false}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.changeDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ changeDateApprovalUrl: v })
                  }}
                />
                <MultipleRecords
                  label="供水设备清洗消毒时间及照片"
                  name="cleanDateApprovalUrl"
                  required={true}
                  rules={{ message: '请选择供水设备清洗消毒时间并上传图片' }}
                  token={props.token}
                  maxCount={3}
                  defaultValue={data?.cleanDateApprovalUrl || []}
                  changeForm={(v) => {
                    form.setFieldsValue({ cleanDateApprovalUrl: v })
                  }}
                />
                <UploadFormItem
                  name="disinfectantHealthApprovalUrl"
                  label="供水设备清洗消毒剂卫生许可批件"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.disinfectantHealthApprovalUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ disinfectantHealthApprovalUrl: v })
                  }
                />
                <UploadFormItem
                  name="disinfectantManufacturerHealthApprovalUrl"
                  label="饮水设备清洗消毒剂生产企业卫生许可证"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={
                    data?.disinfectantManufacturerHealthApprovalUrl || []
                  }
                  changeForm={(v) =>
                    form.setFieldsValue({
                      disinfectantManufacturerHealthApprovalUrl: v,
                    })
                  }
                />
                <UploadFormItem
                  name="qualitySelfTestUrl"
                  label="水质自检记录"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualitySelfTestUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualitySelfTestUrl: v })
                  }
                />
                <Form.Item
                  name="qualityTestDate"
                  label="水质检测时间"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: "200px" }}
                  />
                </Form.Item>
                <Form.Item
                  name="qualityTestResult"
                  label="水质检测结果"
                  rules={[{ required: true }]}
                >
                  <Input allowClear style={{ width: "60%" }} />
                </Form.Item>
                <UploadFormItem
                  name="qualityTestReportUrl"
                  label="水质检测报告"
                  type={2}
                  token={props.token}
                  required={true}
                  defaultValue={data?.qualityTestReportUrl || []}
                  changeForm={(v) =>
                    form.setFieldsValue({ qualityTestReportUrl: v })
                  }
                />
                <UploadFormItem
                  name="ledgerPhotoUrl"
                  label="供水设施卫生管理台账照片"
                  type={3}
                  token={props.token}
                  required={true}
                  defaultValue={data?.ledgerPhotoUrl || []}
                  changeForm={(v) => form.setFieldsValue({ ledgerPhotoUrl: v })}
                />
              </>
            ) : (
              <></>
            )}
          </Form>
        </div>
      </Modal>
    </>
  )
}
